module.exports = __webpack_public_path__ + "static/logo_cypheme_rvb-4f47c975410383d4b0dfe48b56032aa4.svg";